import React from 'react'
import MainProductList, {
  MainProductListProps,
} from 'ui-shared/WrappedInputs/MainProductList'

const VirtualExperienceList: React.FC<MainProductListProps> = (props) => (
  <MainProductList {...props} />
)

export default VirtualExperienceList
